import React, { useState, useRef, useEffect } from "react";
import { SwiperSlide, Swiper } from "swiper/react";
import Image from "next/image";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Navigation, Pagination, Mousewheel } from "swiper/modules";
import Section from "@/components/ui/section";
import cn from "classnames";
import { AnimatePresence, m } from "framer-motion";
export default function History({ journey }) {
  const data = journey;
  const [swiper, setSwiper] = useState();
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (swiper) {
      swiper.on("slideChange", function () {
        setIndex(swiper.realIndex);
      });
    }
  }, [swiper]);

  const breakpoints = {
    1080: {
      slidesPerView: 2.4,
      spaceBetween: 0,
      direction: "vertical",
    },
    991: {
      slidesPerView: 2.4,
      spaceBetween: 0,
      direction: "vertical",
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 2.4,
      spaceBetween: 0,
    },
    325: {
      slidesPerView: 1.3,
      spaceBetween: 0,
    },
  };

  const imageUrl =
      data?.[index]?.image?.data?.attributes?.url || "/images/placeholder.svg";

  const imageAlt =
      data?.[index]?.image?.data?.attributes?.name || "year-image";

  // TODO Change slide on scroll fixed
  return (
    <Section className="bg-[##F6F5F1]">
      <div className="grid lg:grid-cols-2 grid-cols-1 w-full lg:gap-20 md:gap-8 gap-4 border-[1px] border-[#E9E7DE] md:p-8 p-3">
        <div className="py-0 w-full flex flex-col lg:h-[500px] overflow-hidden">
          <p className="text-darkGrey/70 lg:text-[20px] text-base font-havletica lg:pb-6 pb-2 border-b-[0.5px] border-darkGrey/50 mb-8">
            Journey
          </p>
          <Swiper
            onSwiper={setSwiper}
            breakpoints={breakpoints}
            spaceBetween={30}
            loop={true}
            // autoHeight={true}
            // autoplay={{
            //   delay: 4000,
            // }}
            mousewheel={{
              forceToAxis: true,
              sensitivity: 1,
              releaseOnEdges: true,
            }}
            //   effect={"cards"}
            //   //   effect={"fade"}
            grabCursor={true}
            modules={[Navigation, Pagination, Mousewheel]}
            className="w-full history"
          >
            {data?.map((tile, key) => (
              <SwiperSlide key={"card" + key}>
                {({ isActive }) => (
                  <div className="flex lg:flex-row flex-col items-start lg:h-40 lg:w-full lg:gap-12 gap-4">
                    {tile.year && (
                      <div
                        className={cn(
                          "text-darkGrey md:w-[178px] w-fit shrink-0 font-havletica !leading-none transform transition-all duration-300 ease year",
                          {
                            "opacity-100 lg:text-[80px] text-[52px]": isActive,
                            "opacity-10 text-[40px] translate-y-2": !isActive,
                          }
                        )}
                      >
                        {tile.year}
                      </div>
                    )}
                    <div
                      className={cn(
                        "lg:items-center lg:justify-center flex lg:flex-row flex-col lg:gap-12 gap-6 transition-all duration-300 ease",
                        {
                          "opacity-100": isActive,
                          "opacity-0": !isActive,
                        }
                      )}
                    >
                      <div className="bg-darkGrey/50 lg:w-[23px] w-[1px] lg:h-[0.5px] h-[40px] md:shrink-0 ml-4 md:ml-0" />
                      <div className="flex flex-col w-full gap-1">
                        {tile.title && (
                          <p className="text-darkGrey/70 font-havletica md:text-lg text-base capitalize">
                            {tile.title}
                          </p>
                        )}
                        {tile.description && (
                          <p className="text-darkGrey/70 font-light">
                            {tile.description}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="w-full h-auto relative overflow-hidden lg:pt-16">
          <AnimatePresence mode="wait">
            <m.div
              key={index}
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 100, y: 0 }}
              exit={{ opacity: 0, y: -50 }}
              transition={{ duration: 0.3 }}
              className="w-full 2xl:h-[30vw] lg:h-[498px] md:h-[500px] h-[250px] relative"
            >
              {/*<Image
                src={
                  data[index].image.data.attributes.url ??
                  "/images/placeholder.svg"
                }
                alt={data[index].image.data.attributes.name ?? "year-image"}
                sizes="(max-width: 479px) 500px, 800px"
                fill
                className="w-full h-full object-cover object-center"
              />TODO SSS*/}

              <Image
                  src={imageUrl}
                  alt={imageAlt}
                  sizes="(max-width: 479px) 500px, 800px"
                  fill
                  className="w-full h-full object-cover object-center"
              />
            </m.div>
          </AnimatePresence>
        </div>
      </div>
    </Section>
  );
}
